import { checkIsProtocolInvalid} from "./checkIsProtocolInvalid";
import { Protocol } from "./types";

export const addHttpsToTargetValue = (url: string) => {
    const trimmedUrl = url?.trim();
    const isProtocolInvalid = checkIsProtocolInvalid(trimmedUrl);
    if (isProtocolInvalid) return Protocol.HTTPS;

    return trimmedUrl?.startsWith(Protocol.HTTPS) ? url : Protocol.HTTPS + url;
};